import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Page} from '../../../../global/util/enum/Page';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AddEditAdsComponent} from '../add-edit-ads/add-edit-ads.component';
import {Constant} from '../../../../global/util/Constant';
import {AdsService} from '../../../service/ads.service';
import {InformType} from '../../../../global/util/enum/InformType';
import {Dialog} from '../../../../global/util/Dialog';
import {ShowImageAdsComponent} from '../show-image-ads/show-image-ads.component';
import {Ads} from '../../../model/Ads';
import {ConfirmComponent} from '../../../../shared/confirm/confirm.component';
import {Response} from '../../../../global/util/enum/Response';
import {AuthService} from '../../../service/auth/auth.service';
import {Pagination} from '../../../../global/util/Pagination';

@Component({
  selector: 'app-notice-list',
  templateUrl: './list-ads.component.html',
  styleUrls: ['./list-ads.component.css']
})
export class ListAdsComponent implements OnInit {
  public title = 'TITLE.LIST-ADS';
  public listAds: any[] = [];
  public page: any = {};
  public links: any = {};
  public enumPage = Page;
  public loading: boolean;
  public ads: any;
  private adsUrl: string;
  public newListAds: any[] = [];
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(private translate: TranslateService,
              private modalService: NgbModal,
              private adsService: AdsService,
              private authenticationService: AuthService) {
  }

  ngOnInit(): void {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
    this.loadAds(Page.First);
  }

  openAddModal() {
    const addAdsModal = this.modalService.open(AddEditAdsComponent, {
      backdrop: 'static'
    });
    addAdsModal.componentInstance.ads = new Ads();
    addAdsModal.result.then(result => {
      if (result === InformType.Success) {
        Dialog.show(InformType.Success, this.translate.instant(this.title));
        this.loadAds(Page.Self);
      }
    });
  }

  openModalEdit(ads: any) {
    const editAds = Object.assign({}, ads);
    const editAdsModal = this.modalService.open(AddEditAdsComponent, {
      backdrop: 'static'
    });
    editAdsModal.componentInstance.ads = editAds;
    editAdsModal.result.then(result => {
      if (result === InformType.Success) {
        Dialog.show(InformType.Success, this.translate.instant(this.title));
        this.loadAds(Page.Self);
      }
    });
  }

  openModalDelete(ads: Ads) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.DELETE-ADS');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.ARE-YOU-SURE-DELETE-ADS');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.delete(ads);
      }
    });
  }

  loadAds(page: Page) {
    this.loading = true;
    switch (page) {
      case Page.First:
        this.adsUrl = Constant.ROOT_API_V1
          .concat('/notices/?')
          .concat('size=')
          .concat(this.pageNumber)
          .concat('&sort=id,desc');
        break;
      case Page.Previous:
        this.adsUrl = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        this.adsUrl = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        this.adsUrl = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        this.adsUrl = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.adsService.getAll(this.adsUrl).subscribe(next => {
      this.loading = false;
      if (next) {
        this.listAds = next._embedded.ads;
      }
      this.page = next.page;
      this.links = next._links;
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant(this.title));
    });
  }

  viewImages(ads: any) {
    this.newListAds = [];
    const copyAds = Object.assign({}, ads);
    const showImageModal = this.modalService.open(ShowImageAdsComponent, {
      backdrop: 'static',
    });
    this.newListAds.push(copyAds);
    showImageModal.componentInstance.newListAds = this.newListAds;
    showImageModal.componentInstance.viewCheckOption = false;
    showImageModal.componentInstance.title = 'TITLE.VIEW-ADS';
  }

  getUrlImage(imageOnBase64: any) {
    return 'data:' + imageOnBase64.extension + ';base64,' + imageOnBase64.image;
  }

  private delete(ads: Ads) {
    this.loading = true;
    this.adsService.delete(ads.id).subscribe(() => {
      this.loading = false;
      Dialog.show(InformType.Success, this.translate.instant(this.title));
      this.loadAds(Page.Self);
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.DELETE-ADS'));
    });
  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }

  isPresentImage(adsImage: any) {
    return adsImage.image;
  }
}
